import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSmartwatch1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="smartwatch-1, clock, time"><path d="M12 8.75V12L13.5 13.5M4.75 4.75H19.25V19.25H4.75V4.75ZM7 4.75L8 1.75H16L17 4.75H7ZM7 19.25L8 22.25H16L17 19.25H7Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSmartwatch1;
